export { default } from './PlaEstrategic';
